import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Button } from "../ui/button";
import { Badge } from "../ui/badge";
import {
  FolderOpen,
  Download,
  Shield,
  File,
  FileImage,
  FileText,
  FileSpreadsheet,
} from "lucide-react";

const ClientFilesCard = ({ files = [], formatDate, onDownloadFile }) => {
  const getFileIcon = (contentType) => {
    if (contentType?.startsWith("image/")) {
      return <FileImage className="h-5 w-5 text-blue-500" />;
    }
    if (contentType?.includes("spreadsheet") || contentType?.includes("excel") || contentType?.includes("csv")) {
      return <FileSpreadsheet className="h-5 w-5 text-green-500" />;
    }
    if (contentType?.includes("pdf")) {
      return <FileText className="h-5 w-5 text-red-500" />;
    }
    return <File className="h-5 w-5 text-rnb-gray" />;
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return "0 B";
    const k = 1024;
    const sizes = ["B", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + " " + sizes[i];
  };

  return (
    <Card className="mt-8" data-testid="client-files-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <FolderOpen className="h-5 w-5 text-rnb-blue" />
          Client Files ({files.length})
          <Badge variant="outline" className="ml-2">
            <Shield className="h-3 w-3 mr-1" />
            HIPAA Encrypted
          </Badge>
        </CardTitle>
      </CardHeader>
      <CardContent>
        {files.length > 0 ? (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
            {files.map((file) => (
              <div
                key={file.file_id}
                className="flex items-center justify-between p-4 bg-slate-50 rounded-lg hover:bg-slate-100 transition-colors"
                data-testid={`admin-file-${file.file_id}`}
              >
                <div className="flex items-center gap-3 min-w-0">
                  {getFileIcon(file.content_type)}
                  <div className="min-w-0">
                    <p className="font-medium text-rnb-navy truncate" title={file.original_filename}>
                      {file.original_filename}
                    </p>
                    <p className="text-xs text-rnb-gray">
                      {formatFileSize(file.size_bytes)} • {formatDate(file.created_at)}
                    </p>
                  </div>
                </div>
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => onDownloadFile(file.file_id, file.original_filename)}
                  data-testid={`admin-download-${file.file_id}`}
                >
                  <Download className="h-4 w-4" />
                </Button>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-8">
            <FolderOpen className="h-12 w-12 text-rnb-gray/30 mx-auto mb-4" />
            <p className="text-rnb-gray">No files uploaded by this client</p>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default ClientFilesCard;
